module.exports = __webpack_public_path__ + "static/media/feature-1.315b61e4.jpg";